import { useQuery } from '@tanstack/react-query';
import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';
import { filtersToStringArray } from '@/utils/filtersToStringArray.ts';
import type { Trip } from '$/models/Trip.model.ts';
import tripRepository from '@/api/repositories/tripRepository/TripRepository.ts';

const useTrips = (enabled: boolean = true, filters: Filters<Trip> | undefined = undefined) => {
  const queryKey = ['trips', ...filtersToStringArray(filters)];

  const queryFn = async () => {
    return getAction(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useTrips;

async function getAction(filters?: Filters<Trip>): Promise<Trip[]> {
  const { data, error } = filters
    ? await tripRepository.findMany(filters, {
        order: {
          by: 'created_at',
          ascending: true,
        },
      })
    : await tripRepository.all({
        order: {
          by: 'created_at',
          ascending: true,
        },
      });

  if (error) throw new Error(error.message);

  return data ?? [];
}
